<div class="filters-box">
  <div class="filters">
    <div>
      <app-select [options]="sortColumnOptions"
                  [small]="true"
                  [(ngModel)]="sortColumn"
                  (ngModelChange)="filter()"
      ></app-select>
    </div>
    <div>
      <app-select [options]="sortDirectionOptions"
                  [small]="true"
                  [(ngModel)]="sortDirection"
                  (ngModelChange)="filter()"></app-select>
    </div>
    <div class="form form-no-width">
      <input [(ngModel)]="search"
             (ngModelChange)="filter()"
             class="small-input"
             placeholder="zoek..."
             type="text">
    </div>
  </div>
  <div class="pagination">
    <mat-paginator #paginator
                   (page)="pageEvent = getTransactions($event)"
                   [length]="length"
                   [pageSize]="this.pageSize"
                   hidePageSize="true">
    </mat-paginator>
  </div>
</div>
<div class="clearFix"></div>

<div *ngIf="transactions?.length == 0">
  <div class="spacer"></div>
  <p class="mb14 align-center">
    wanneer alle transacties over het rapportagejaar zijn gecategoriseerd kunt u de rekening en verantwoording verder
    invullen
  </p>
  <button class="btn check center-x accent" [routerLink]="'/bewind/'+client?.id+'/rapportage'">maak rapportage</button>
</div>

<div *ngFor="let transaction of transactions">
  <div *ngIf="!transaction.hidden"
       [@items]
       class="overflow-hidden">
    <div (click)="open(transaction)"
         [ngClass]="transaction.debitCredit"
         class="transaction unassigned overflow-hidden">
      <div class="transaction-amount center">
        <div class="value">
          {{transaction.debitCredit == 'C' ? '+' : '-'}}
          {{currencyService.symbol(transaction.currency) + currencyService.format(transaction.amount)}}
        </div>
        <div class="date">{{transaction.valueDate}}</div>
      </div>
      <div class="transaction-details">
        <div class="flex">
          <div class="col-6 pt14">
            <div class="header">IBAN</div>
            {{transaction.iban ? transaction.iban : '-'}}
          </div>
          <div class="col-6">
            <div class="full-width form form-no-width">
              <input (focus)="transaction.openPicker = true;"
                     (keydown)="keydown($event)"
                     [(ngModel)]="transaction.search"

                     data-subcategory-trigger="true"
                     placeholder="subcategorie"
                     type="text">
            </div>
          </div>
        </div>
        <div class="flex">
          <div [ngClass]="{ 'col-6 word-break' : hasSuggestions(transaction)}" class="pt14 pr12">
            <div class="header">
              omschrijving
            </div>
            {{transaction.transactionDescription}}
          </div>
          <div *ngIf="hasSuggestions(transaction)" class="pt14 col-6">
            <div>
              <div class="header">
                suggesties
              </div>
              <ul class="m0 pl20">
                <li *ngFor="let suggestion of transaction.suggestions">
                  <span (click)="save(suggestion.subcategoryId, transaction, 'SUGGESTION')"
                        class="pointer link">{{suggestion.subCategoryName}}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="transaction.openPicker" [@expandCollapse] class="overflow-hidden">
    <app-subcategory-picker (clickOutside)="onClickedOutside($event)"
                            (subcategoryFound)="save($event, transaction, 'SELECTION')"
                            [categories]="transaction.debitCredit === 'D' ? categories.debit : categories.credit"
                            [enterPressed]="enterPressed"
                            [search]="transaction.search"></app-subcategory-picker>
  </div>
</div>
